/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CancelFeedbackRequestReasonCode } from './cancelFeedbackRequestReasonCode';

export interface CancelFeedbackRequest {
  reason_code: CancelFeedbackRequestReasonCode;
  reason_text?: string | null;
}
